import { render, staticRenderFns } from "./DataManageTree.vue?vue&type=template&id=63465cfd&scoped=true"
import script from "./DataManageTree.vue?vue&type=script&lang=js"
export * from "./DataManageTree.vue?vue&type=script&lang=js"
import style0 from "./DataManageTree.vue?vue&type=style&index=0&id=63465cfd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63465cfd",
  null
  
)

export default component.exports